import { Li } from 'facades'
export default function Service() {
  return (
    <div>
      <p>
        歡迎使用StyleMap之系統平台（以下簡稱「本平台」）等相關服務（以下簡稱「本服務」），本服務係由髮弄資訊股份有限公司（以下簡稱「本公司」）提供，以行動應用程式或網頁提供相關資訊及技術支援，協助媒合髮型設計師（以下簡稱「設計師」）及消費者（以下合稱「使用者」或「您」），由設計師提供美髮服務、販售美髮產品等服務予消費者。本使用者條款（以下簡稱「本條款」）規範本服務之內容及您的權利義務，請您務必詳細閱讀，並遵守本條款及本服務之相關規範。
      </p>
      <Li level='1' number='1' text='認知與接受條款' />
      <List array={ list[0] } level='2'/>
      <Li level='1' number='2' text='服務內容' />
      <List array={ list[1] } level='2'/>
      <Li level='1' number='3' text='隱私權保護' />
      <div { ...list[2].rawHtml() }/>
      <Li level='1' number='4' text='付款方式' />
      <List array={ list[3] } level='2'/>
      <Li level='1' number='5' text='免責條款' />
      <List array={ list[4] } level='2'/>
      <Li level='1' number='6' text='著作權條款' />
      <List array={ list[5] } level='2'/>
      <Li level='1' number='7' text='費用' />
      <List array={ list[6] } level='2'/>
      <Li level='1' number='8' text='特約條款' />
      <List array={ list[7] } level='2'/>
      <Li level='1' number='9' text='帳戶安全' />
      <List array={ list[8] } level='2'/>
      <Li level='1' number='10' text='禁止事項' />
      <div>
        您應擔保於使用本服務期間，不得從事以下任一行為，本公司並得於不事先通知您之情況下，即終止對您提供本服務之全部或一部：<br/>
        <List array={ list[9] } level='2'/>
      </div>
      <Li level='1' number='11' text='退款' />
      <div { ...list[10].rawHtml() }/>
      <Li level='1' number='12' text='期限與終止' />
      <div { ...list[11].rawHtml() }/>
      <Li level='1' number='13' text='違約處理' />
      <List array={ list[12] } level='2'/>
      <Li level='1' number='14' text='準據法與管轄法院' />
      <div { ...list[13].rawHtml() }/>
      <Li level='1' number='15' text='通知' />
      <div { ...list[14].rawHtml() }/>
      <Li level='1' number='16' text='其他' />
      <List array={ list[15] } level='2'/>
    </div>
  )
}

const List = ({ array, level }) => array.map((text, index) => (
  <Li key={ index } level={ level } number={ index + 1 } text={ text }/>
))

const list = [
  [
    '您須先詳閱並同意本條款之內容，並於提供真實、正確及最新、有效之個人資料以完成註冊程序後，始可開始使用本服務。您瞭解當您開始使用本服務或註冊成為本平台之會員後，即視為您已詳閱、瞭解本條款之所有內容，並同意受其拘束。',
    '本公司將不定時更新修訂本條款，該修訂之最新版本將於發布時即當然生效，本公司將不再另行通知，然若本條款發生對您於本條款下之權益有任何不利之重大變更時，本公司將提供您至少7日前之書面通知。您應定期察看本條款之內容，若您不同意修訂之內容，請您停止使用本服務。若您於該等更新修訂發布後，仍有繼續使用本服務之情事，則視為您同意接受更新修訂之本條款內容所拘束。',
    '本服務不提供二十歲以下之未成年人使用，倘您為二十歲以下之未成年人(包括限制行為能力人者或無行為能力人者)，應由您的法定代理人或監護人閱讀並同意本條款，始可開始使用本服務。',
    '您同意本服務可能會向您發送資訊文字訊息，此為您使用本服務時正常業務營運的環節之一。您可隨時透過客服信箱：service@hairdodo.com 並依據其指示表明您不再希望接收來自本公司之簡訊。您瞭解選擇不再接收簡訊可能會影響您使用本服務一部或全部之權利。'
  ],
  [
    '您應先行依照您的使用目的註冊相關帳戶（以下簡稱「帳戶」），除本公司另有書面許可外，您只能註冊一個帳戶，您必須對您註冊帳戶下之所有活動負擔一切責任。倘您為二十歲以下之未成年人(包括限制行為能力人者或無行為能力人者)則須於法定代理人或監護人之同意及監督下，方得使用或繼續使用本服務。',
    '本公司在此授與您非專屬的、有限的、非排他性的、不可分、可撤銷、不可轉讓之權利，得依據本條款及本服務內所揭示之條件使用本服務。本服務所顯示之內容(包含但不限於本服務所顯示之影片、文字、聲音、圖形、電腦程式、商標等)之智慧財產權、所有權及相關權利皆不因此移轉為您所有，而由本公司或其授權人所有。您僅能於本公司事先合法書面授權之情形下，於本公司明示之授權範圍內使用前開內容。除本公司與您單獨達成之協議中另有約定外，本服務僅供您個人、非商業性之使用。',
    '本公司有權隨時變更或終止本服務內容之一部或全部(包含但不限於功能、平台服務費用、取消費用、稅費等)，本公司將於變更或終止相關內容時通知您，倘您不同意變更後之內容，請立即停止使用本服務。若您於該等修訂後，仍有繼續使用本服務之情事，則視為您已詳閱最新修訂之服務內容，並同意受其拘束。',
    '本公司保留隨時依自身決定，認定是否終止對您提供本服務之權利，而無須事先以書面通知您或取得您的同意。',
    '如本公司對特定活動另訂其他規範或有其他約定時，您亦應遵守該特定活動之相關規範，倘與本條款之解釋或適用有衝突時，本公司保留最終解釋適用之權利。',
    <div key='2-6'>
      於下列情況下，本公司得不事先通知您即終止或暫停提供本服務之全部或一部，您並同意本公司不因此對您或任何第三方負擔任何責任：
      <List array={
        [
          '因本公司無法控制、無法預見或雖然可以預見但無法避免的任何不可抗力事件，包括但不限於騷亂、爆炸、火災、洪水、地震及其它自然災害及戰爭、民衆騷亂、故意破壞、徵收、沒收、政府主權行爲、法律變化或未能取得政府對有關事項的批准或因政府的有關强制性規定和要求致使本公司無法提供訂閱服務時；',
          '系統之維護或維修；',
          '系統故障或系統過載；',
          '為維護公眾利益時；',
          '為保護您或第三人之安全時；',
          '為配合公務機關執行公務時；或',
          '於本公司合理認為有必要時。'
        ]
      } level='3'/>
    </div>,
    '本服務可能因您所使用的相關設備您的使用區域或設備之所在地，而有部分或全部受到限制，或不能使用之情形，倘您欲繼續使用本服務，您應自備相關軟硬體設施，並排除限制使用本服務之障礙事由。',
    '本服務可能會出現中斷、故障、過載等情形，而造成您無法使用、資料喪失、錯誤、或其他損失等情形，您同意除因本公司之故意或重大過失所致者外，本公司不就此負擔任何責任。'
  ],
  '本公司為提供本服務，可能需要您提供您的個人資料予本公司蒐集使用，本公司並將遵循本公司發佈之「隱私權聲明」https://style-map.com/terms，以及中華民國個人資料保護法與其他適用之相關規範儲存、蒐集及利用您的個人資料。您瞭解並同意遵守以上關於個人資訊之相關規定，並應保證或持續更新以確保提供予本公司之個人資訊皆為真實、完整、正確、最新及有效，倘若您未提供、維持或更新您的個人資訊為真實、完整、正確、最新及有效，包含但不限於付款方式過期或無效等情事，您將可能無法使用或繼續使用本服務之一部或全部，本公司並保留是否提供或終止提供本服務予您之權利，本公司因本服務向您收取之費用將不退還。',
  [
    '本公司提供「美Pay支付」(信用卡、簽帳金融卡、Google Pay、Apple Pay、LINE Pay、全盈+Pay、零卡分期) 作為付款方式，您應真實、完整、正確、最新及有效填寫付款頁面所需之相關資訊(以下簡稱「付款資訊」)，包含但不限於信用卡卡號、持卡人姓名、持卡人地址、第三方付款處理商所需之相關資訊等，您應保持您的付款資訊為真實、完整、正確、最新且有效。倘您以跨國信用卡作為付款工具，您需先行啟用跨國交易之功能。',
    '付款方式之發行機構或第三方付款處理商可能會向您收取特定費用，如跨國交易手續費或其他與您付款方式有關之處理費用。當地稅額可能因您所使用的付款方式及匯率之變動而有不同，倘您對此有任何疑問，請您向您的付款處理商進行諮詢。',
    '您可透過「美Pay付款設定」更新您的「付款方式」。您完成付款方式之更新後，即代表您同意授權本公司繼續透過您所選擇之「付款方式」收費。',
    '您瞭解並同意，本公司為提供您更好的使用並完善本服務，某些付款方式會將您導向至第三方網站。除本條款外，您亦應遵守第三方付款處理商及付款方式發行機構所發佈之相關規範。若前開單位發生任何錯誤，與本公司無涉，本公司不就此負擔任何責任。',
    '您瞭解並同意於本條款有規定之狀況下，本公司有權視情況要求您支付取消費用或其他相關費用以補償其他使用者或第三人之可能損失，您並授權本公司得按照您所選之付款方式直接扣款或索取該等費用。',
    '如果您的付款方式被拒絕或無效，本公司會向您寄送付款失敗通知。倘您欲繼續使用本服務，您應於收受付款失敗通知後即刻向您的付款方式之發行機構或第三方付款處理商回報處理，或是更改您的付款方式。'
  ],
  [
    '您瞭解並同意，除中華民國法令另有規定外，本服務之內容係按照您使用當時之「現況」及「現有」之基礎所提供。',
    '您明白且同意，本公司僅為媒合平台，除本條款明示約定外，本公司並不就本服務(包含但不限於本服務之內容、本服務之商品、優惠、廣告內容、文字與圖片之說明或其他銷售資訊)、連結的第三方網站內容或您與其他使用者間達成之約定的無瑕疵性、準確性、適銷性、完整性、真實性、有效性、品質、可用性、時間性、適法性為任何默示或明示之保證。您應自行承擔使用本服務之一切風險，並就因使用本服務所為之一切行為及其所產生之任何結果自行負擔一切責任。',
    '您瞭解並同意，倘因本服務而發生於您與其他使用者之間的任何爭議，相關之責任義務存在於您和該名使用者之間，本公司不就此承擔任何責任(包含但不限於個人之侵權行為、刑事責任等)，然為提供您更完善之服務，本公司願意(但非本公司之義務)協助解決相關爭議，您可透過客服信箱：service@hairdodo.com 聯絡本公司尋求相關協助。',
    '您瞭解並同意，在法律允許範圍內，除本條款另有明示約定外，您同意本公司不對您負擔任何責任，包括因使用或無法使用本服務、或您與其他使用者、或您因第三人和其他使用者間之故意或過失而引起的直接、間接、附帶、特殊、衍生性或懲罰性之損失或賠償（包含但不限於營收、利潤、商譽、資料遺失、資料錯誤或其他無形損失）或其餘損害。倘前述的損害係因本公司故意或過大過失所引起者，您同意本公司僅負擔直接之經濟上損失，且向您依法所應擔負之最高賠償金額應為您過去一個月內因使用服務而已支付予本公司之總金額。',
    '您瞭解並同意，倘您不正確使用或濫用美Pay支付功能，而有進行功能銷售預付性交易或銷售遞延性商品或服務，而產生消費者爭議或致本公司受有損害，相關之責任義務存在於您和該名使用者之間，您應自行承擔並負責解決，然本公司有權不經您同意決定處理方式，包含但不限於退費、賠償、訴訟、和解、調解等，您有義務依照本公司之指示給予協助，本公司同時保留向您請求本公司因此所生之一切損害(包括但不限於第三人因您的行為而向本公司請求之損害賠償、訴訟費用及合理之律師費等)。'
  ],
  [
    '您於本平台上所上傳、發佈、使用或以其他方式發送(以下簡稱「發佈」)之內容，包含但不限於文字、圖片、音訊及影片等（以下簡稱「使用者內容」），其所有權、智慧財產權及相關權利均為您所有，您應自行負責使用者內容之儲存、保管及維護等相關責任。您並保證使用者內容確實為您合法所有或已獲得合法授權，您發佈於本平台之行為不會侵犯第三方的智慧財產權及所有權利（包括但不限於隱私權、肖像權、姓名權及名譽權等），或違反任何應適用之法律或政府法令。',
    '您同意授權本公司得永久性、可轉讓地、不可撤回地、無償地利用使用者內容，且本公司有權就使用者內容為再授權、使用、重製、修改、衍生創作、散布、公開展示、公開傳播、公開傳輸及以其他任何形式之使用行為，而無須另行事先書面通知或取得您或其他第三方(包含但不限於授權人)之同意，本公司亦無需向您或任何第三方支付任何費用。您並保證本公司前開之使用行為不會侵犯第三方的智慧財產權及所有權利（包括但不限於隱私權、肖像權、姓名權及名譽權等），或違反任何應適用之法律或政府法令。',
    '您應擔保所提供的使用者內容中不含任何違反第八條之內容，本公司並有權在未經事先通知或取得您或其他第三方(包含但不限於授權人)同意之情況下，隨時審查或移除使用者內容。倘有任何第三方就您的使用者內容向本公司提出申訴、舉報、刪除、更改等要求，本公司有權於未事先通知或取得您或其他第三方(包含但不限於授權人)之同意的情形下，自行針對使用者內容為本公司認為適當之一切處置。您應擔保本公司不需因此負擔任何之損害或額外成本，並無條件依本公司之指示提供一切協助。',
    '您同意並瞭解，倘因您違反本條之內容而因此產生任何爭議(包含但不限於訴訟、和解、仲裁、行政裁罰等)，皆與本公司無涉，您應自行負擔一切責任，您並同意無條件賠償本公司因此所生之損害或所失利益。'
  ],
  [
    '於本服務上所顯示之每一筆訂單，您將依照你所選之服務功能對設計師支付服務費用或選物費用等相關費用（合稱「該費用」）。該費用將依您實際消費方式、所選服務功能、優惠方案及不同設計師等不同因素有所差異。每位設計師皆有權自行決定其對服務和產品的收費，以及於本服務上所提供之服務選項，您瞭解其可能與您在店家實際看到之資訊有所差異，您之訂單內容應以本平台所顯示之資訊為準。本服務所顯示之費用皆為含稅價格。',
    '該費用的支付，係由本公司以代收該費用之設計師代理人身份，按照您所選擇之付款方式，協助設計師完成收款。除經本公司確定或符合中華民國相關法令之規定，您已支付的該費用將不予退還。'
  ],
  [
    (
      <div key='0'>
      消費者適用條款:倘您為消費者，須適用本項之規定。
        <List array={
          [
            (
              <div key='0'>
            預約服務：<br/>
            倘您欲使用使用線上預約服務，您需先行開通美Pay支付功能，並按本平台所顯示「美Pay付款設定」之內容，填寫您真實、完整、正確、最新及有效之相關資訊。
              </div>
            ),
            (
              <div key='1'>
            消費者未赴約：<br/>
            使用線上預約之消費者，如有未於預約時段前往消費之情況發生，本公司將向您自動收取該次預約服務費用區間之最低價格的百分之五十(50%)，作為服務費用。
              </div>
            ),
            (
              <div key='2'>
            臨時取消預約：<br/>
            倘您為使用線上預約之消費者，您應遵守預約設計師設定於本平台顯示頁面之「臨時取消預約限制」。倘有未遵守「臨時取消預約限制」而臨時取消預約之情節發生，本公司將向您自動收取該次預約服務費用區間之最低價格的百分之十五(15%)～百分之三十(30%)，作為「服務費用」。
              </div>
            )
            ,
            (
              <div key='3'>
              本平台之「臨時取消預約限制」如下：<br/>
                <List array={
                  [
                    '原預訂之服務開始4小時前，消費者可免費取消預約。',
                    '原預訂之服務開始前2小時~4小時內取消預約，消費者須負擔當次預約服務最低價位的百分之十五(15%)。',
                    '原預訂之服務開始前2小時內取消預約，消費者須負擔當次預約服務最低價位的百分之三十(30%)。'
                  ]
                }
                level='4'
                />
              </div>
            )
            ,
            '倘以上情形經本公司查證係可歸責於設計師所致，本公司將退還您因因此所支付之前開服務費用。您可透過客服信箱： service@hairdodo.com 向本公司進行以上情形之申訴。'
          ]
        } level='3'/>
      </div>
    ),
    (
      <div key='1'>
        設計師適用條款:倘您為設計師，須適用本項之規定。<br/>
        <List array={
          [
            '倘您欲開放提供消費者使用美Pay支付功能，您需先行開通美Pay支付功能，並按本平台所顯示「美Pay收款設定」之內容，填寫您真實、完整、正確、最新及有效之相關資訊。',
            (
              <div key='1'>
                設計師收款約定<br/>
                <List array={
                  [
                    '「美配特約店設計師」定義：與本公司簽訂合作合約，於指定場地提供服務之設計師。',
                    (
                      <div key='1'>
                        非美配特約店設計師適用以下約定：<br/>
                        倘您提供消費者使用美Pay支付功能，您同意負擔每次使用美Pay支付交易所收取金額的百分之十(10%)作為本平台服務費用。
                      </div>
                    ),
                    (
                      <div key='2'>
                        美配特約店設計師適用以下約定：<br/>
                        當您提供消費者使用美Pay支付功能，您同意負擔每次使用美Pay支付交易所收取金額的百分之二十五(25%)作為本平台服務費用。
                      </div>
                    ),
                    '本公司將於協助您完成消費者支付費用之收款後，扣除前項之本平台服務費用後，最遲於次月10日前，全數撥款至您於本平台之「美Pay收款帳戶」，您可隨時提領至您設定之銀行帳號，美配將扣除匯款手續費15元後匯入。',
                    '根據信用卡國際組織規定，使用者因對交易商品或服務之內容有疑義而透過發卡機構主張返還款項時，本公司得不另經設計師同意逕行退款，並自設計師暫留於本平台之款項中扣除，若設計師暫無留存於本平台之款項，本公司將以未來代設計師所收之款項抵付。'
                  ]
                }
                level='4'
                />
              </div>
            ),
            (
              <div key='2'>
                禁止約定:<br/>
                您不得使用美Pay支付或本平台進行預付性交易或銷售遞延性商品或服務，包含但不限於儲值、套票、預付月費、預付年費等商品，是否構成遞延性商品或服務有本公司自行決定之。倘有本項情形發生，並經本公司查證屬實時，本公司有權終止您繼續使用美Pay支付功能之權利。為有效預防銷售遞延性商品或服務之情形發生，本公司對於每筆美Pay支付上限為新台幣五萬元。倘您非因為有效銷售遞延性商品或服務之情形發生而有單筆支付超過新台幣五萬元以上之情形，您可透過美Pay支付進行分次結帳，然本公司有權向您查證確認支付之服務內容，以釐清是否有違反本條款之情事，您承諾將如實依照本公司之指示提供真實正確之相關資訊。
              </div>
            ),
            (
              <div key='3'>
                為確保消費者支付體驗，倘有下列任一情形發生，並經本公司查證屬實時，您需以該次交易所收取金額的百分之五十(50%)作為「懲罰性違約金」支付予本公司。<br/>
                <List level='4'
                  array={ [
                    '您針對使用美Pay支付之消費者，收取高於消費者「使用現金支付之價格」的情況。',
                    '您不熟悉、不黯、不能或無法操作美Pay支付，以致消費者最終無法使用美Pay支付進行結帳。',
                    '您直接或間接拒絕讓消費者使用美Pay支付進行結帳。',
                    '您無正當理由拒絕服務、不在現場、遲到或任何得歸責於您之狀況，而導致消費者所選定之服務無法完成時。'
                  ] }
                />
              </div>
            ),
            (
              <div key='4'>
                設計師遇消費者臨時取消預約補償條件：<br/>
                <List level='4'
                  array={
                    [
                      '使用線上預約之消費者倘有未遵守「臨時取消預約限制」而有臨時取消預約之情節發生時，本公司向消費者所收取之「服務費用」中的百分之九十(90%)將支付予您作為「補償服務費」，其餘的百分之十(10%)則由本公司保留作為「平台服務費」。',
                      (
                        <div key='1'>
                          本平台之「臨時取消預約限制」如下：<br/>
                          <List
                            level='5'
                            array={
                              [
                                '原預訂之服務開始4小時前，消費者可免費取消預約。',
                                '原預訂之服務開始前2小時~4小時內取消預約，消費者須負擔當次預約服務最低價位的百分之十五(15%)。',
                                '原預訂之服務開始前2小時內取消預約，消費者須負擔當次預約服務最低價位的百分之三十(30%)。'
                              ]
                            }
                          />
                        </div>
                      )
                    ]
                  }
                />
              </div>
            ),
            (
              <div key='5'>
                設計師遇消費者未赴約之補償條件：<br/>
                <List level='4'
                  array={ [
                    '使用線上預約之消費者倘有符合『未赴約條件』而被您回報為『爽約』，本公司向消費者所收取之「服務費用」，其中的百分之九十(90%)將支付予您作為「補償服務費」，剩餘的百分之十(10%)則由本公司保留作為｢平台服務費」。',
                    (
                      <div key='1'>
                        本平台之「未赴約條件」如下：<br/>
                        <List level='5'
                          array={ ['原預訂之服務時間結束前消費者未取消預約，亦未抵達事先約定之服務現場，亦未通知您無法赴約，消費者須負擔當次預約服務最低價位的百分之五十(50%)。'] }
                        />
                      </div>
                    )
                  ]
                  }
                />
              </div>
            )
          ]
        }
        level='3'
        />
      </div>
    )
  ],
  [
    '您充分瞭解網際網路非百分之百安全之環境，並可能存在事實上或法律上之瑕疵（包含但不限於與安全性、可靠性、正確性、完整性、有效性、針對特定目的之適用性、安全等相關之缺陷、錯誤、漏洞、權利侵害等），你同意對使用本服務及提供予本公司的資訊(包含但不限於帳號密碼、使用者內容等)善盡保管義務及防護責任，以避免外洩或遭第三人取用，您應對自身未善盡保管義務及防護責任所引起之損害負擔一切責任，您亦同時瞭解並同意自行承擔網際網路之環境風險及因此所引起之損害。',
    '倘若你發現提供予本公司之資料，包含但不限於帳戶或使用本服務所產生之相關資料，遭第三人未經合法授權地使用，或發生任何資訊安全之問題，你應即刻通知本公司客服信箱：service@hairdodo.com ，並全力協助本公司處理後續事宜。',
    '無論明示或暗示，倘本平台及本服務含有第三方連結及網站(包含但不限於第三方付款處理上、銀行、付款方式發行機構等)，本公司並不保證其不存在事實上或法律上之瑕疵（包含但不限於與安全性、可靠性、正確性、完整性、有效性、針對特定目的之適用性、安全等相關之缺陷、錯誤、漏洞、權利侵害等），您瞭解並同意本公司不就第三方對您引起的任何損害負擔責任。'
  ],
  [
    '有違反中華民國或其餘國家之法令、法院判決、裁定或命令或具有法令拘束力的行政命令、主管機關發布或有違反之虞的行為。',
    '有違反公共秩序或善良風俗或有違反之虞的行為。',
    '有侵害著作權、商標權、專利權等智慧財產權、名譽權、隱私權、肖像權、其他依據法令或其他第三人權利或有侵害之虞的行為。',
    '有任何暴力、淫穢、性暗示、侮辱性、攻擊性或關於人種、國籍、信仰、性別等歧視之行為、表現或言語，或有引誘或助長自殺、自傷行為或濫用藥物、毒品或其他反社會情節在內之行為、表現或言語。',
    '有假冒本公司或第三人，或其代理人，或以他人之名義散布不實資訊的行為。',
    '有散布不實資訊或妨害名譽於本公司、其他使用者或第三人，或有散布之虞的行為。',
    '有干擾本服務之伺服器、軟硬體之行為，或其他妨礙本公司營運、提供本服務或其他使用者使用本服務，或有以上干擾妨害之虞的行為。',
    '有修改、編輯或翻譯訂閱服務或訂閱服務系統、軟體、編碼等行為，或有逆向工程、反編譯、反彙編、或其他對訂閱服務之原始碼進行探究、解碼之行為，或有以上行為之虞的行為；本公司合理懷疑您有以上行為時；或其他本公司認為不適當的行為。'
  ],
  '除本條款另有規定外，本公司不會就終止提供本服務或本服務因任何原因而暫時無法使用(包含但不限於資訊安全問題、不可抗力事件等)，退還任何您先前已給付之費用。',
  '本條款之有效期間，應自您正式註冊為本平台之帳戶後生效至您終止使用本服務之日止，或本服務提前終止或本公司不再提供您本服務時為止，然您的於本條款之保證責任、及您於本條款第二條至第十四條下所負擔之義務及責任仍持續有效存在。',
  [
    '倘您於使用本服務時，有違反本條款、中華民國法令或其他關於本服務之相關規範，或本公司自行決定您不適宜使用本服務時，或您未支付本服務之相關費用時，本公司有權自行決定暫停、終止、取消、不再提供您使用本服務之全部或一部，或為其他本公司認為適宜之處置。本公司且得同時移除、刪除您全部或一部的相關資料(包含但不限於使用者內容、註冊帳戶、付款資訊、個人資訊等)，並不因此對您或第三人負擔任何責任。本公司同時保留向您請求本公司因此所生之一切損害(包括但不限於第三人因您的行為而向本公司請求之損害賠償、訴訟費用及合理之律師費等)。',
    '倘您因前項事由而遭本公司暫停、終止、取消、不再提供您使用本服務之全部或一部時，您先前已給付予本公司之費用，將不予退還。'
  ],
  '本條款及本服務相關規範之解釋、履行及效力悉依中華民國法律為準據法，並以台灣台北地方法院為第一審管轄法院。',
  '本公司可能會以電子郵件、一般郵件、手機簡訊、在訂閱服務網站公佈或以其他法律允許且認可之方式，或其他現在或未來合理之方式通知您。您得以書面形式將通知寄送至本公司以下之地址：新北市林口區仁愛路二段502號5樓506室。',
  [
    '本公司未能實行或行使本條款之任何規定或任何法律行動，並不視為本公司放棄實行之權利。',
    '您不得將使用訂閱服務的一切權利轉讓、出借、設質、處分或以其他方式授予第三人。但本公司依實際業務需要得轉讓本條款所生之任何權利和義務予任何第三人。',
    '您不因與本公司間簽訂任何合約或使用本服務，而取得或與本公司或任何第三方之間成立任何合資、合夥、僱傭、代理或任何非本條款特別明示約定之關係。',
    '本條款有一部被宣告為違法、無效或不可執行，其餘條款並不受該部分之影響。',
    '本條款中使用之標題僅為方便閱讀而使用，將不用於詮釋意義或意圖。',
    '若您對本條款所列事項有疑問，請聯絡客服信箱：service@hairdodo.com 。'
  ]
]
